import DefaultProps from '../../commonTypes/defaultprops.types';
import Handler from '../../commonTypes/handler.types';
import React from 'react';

export enum NewsletterOptinMessageIcons {
  ERROR = 'error',
  DEFAULT = 'default',
  CHECK = 'check'
}

export interface NewsletterOptinProps extends DefaultProps {
  newsletterIds: number[];
  buttonHandlers?: Handler;
  disableInputs?: boolean;
  email?: string;
  emailInputRef?: React.Ref<HTMLInputElement>;
  inputHandlers?: Handler;
  logoDark?: string;
  logoLight?: string;
  messageIcon?: NewsletterOptinMessageIcons;
  placeholder?: string;
  showInputs?: boolean;
  submitText?: string;
  title?: string;
}

export interface NewsletterLogoProps {
  logoLight?: string;
  logoDark?: string;
  darkTheme?: boolean;
}

export interface NewsletterOptinStyleProps {
  dark?: boolean;
  messageIcon?: NewsletterOptinMessageIcons;
}
